export default __webpack_public_path__ + "static/media/empty_dashboard_icon.6f285425.svg";